import React, { useState } from 'react';

const ExpandableCard = ({ 
  icon, 
  title, 
  summary, 
  details, 
  color = '#3b82f6',
  style = {} 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div 
      className="card" 
      style={{ 
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        borderTop: `4px solid ${color}`,
        ...style
      }}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {icon && <span style={{ fontSize: '2rem' }}>{icon}</span>}
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color, margin: 0 }}>
            {title}
          </h3>
        </div>
        <div style={{ 
          fontSize: '1.5rem', 
          color,
          transition: 'transform 0.3s ease',
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
        }}>
          ▼
        </div>
      </div>
      
      <p style={{ lineHeight: '1.7', marginBottom: isExpanded ? '1rem' : 0 }}>
        {summary}
      </p>
      
      {isExpanded && (
        <div style={{ 
          marginTop: '1rem',
          paddingTop: '1rem',
          borderTop: `2px solid ${color}20`,
          animation: 'fadeIn 0.3s ease'
        }}>
          {typeof details === 'string' ? (
            <p style={{ lineHeight: '1.7' }}>{details}</p>
          ) : (
            details
          )}
        </div>
      )}
      
      <div style={{ 
        marginTop: '1rem', 
        fontSize: '0.85rem', 
        color: '#94a3b8',
        textAlign: 'center',
        fontStyle: 'italic'
      }}>
        {isExpanded ? '👆 Click para contraer' : '👆 Click para expandir'}
      </div>
    </div>
  );
};

export default ExpandableCard;
